import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginScreen from './components/LoginScreen';
import AuthVerify from './components/AuthVerify';
import BillyStartScreen from './components/BillyStartScreen';
import BillyMonitorScreen from './components/BillyMonitorScreen';
import BillyLiveScreen from './components/BillyLiveScreen';
import MzPorterGateway from './components/MzPorterGateway';
import CookiePolicy from './components/CookiePolicy';
import TestLiveScreen from './components/TestLiveScreen';
import usePageTracking from './hooks/usePageTracking';

function AppRoutes() {
  usePageTracking();

  return (
    <Routes>
      {/* Authentication Routes */}
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/auth/verify" element={<AuthVerify />} />

      {/* Protected Operator/Tech Support Screens */}
      <Route
        path="/billy/start"
        element={
          <ProtectedRoute allowedRoles={['operator', 'tech_support']}>
            <BillyStartScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/billy/monitor"
        element={
          <ProtectedRoute allowedRoles={['operator', 'tech_support']}>
            <BillyMonitorScreen />
          </ProtectedRoute>
        }
      />

      {/* Public Viewer Screen */}
      <Route path="/live" element={<BillyLiveScreen />} />

      {/* Mz. Porter Gateway Page */}
      <Route path="/mz-porter" element={<MzPorterGateway />} />

      {/* Cookie Policy */}
      <Route path="/cookie-policy" element={<CookiePolicy />} />

      {/* Test Page */}
      <Route path="/test-live" element={<TestLiveScreen />} />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/mz-porter" replace />} />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/mz-porter" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
